import { Alpine } from "./main.alpinejs.js";
// Store variables
import "./stores/oneTrustStore.js";
import "./stores/sectionIdStore.js";
import "./stores/translationStore.js";

import siteConfig from "./modules/siteConfig";

// Register components we will lazy load
// TODO: Use alias for dynamic alpine component registration https://async-alpine.dev/docs/usage/#alias
// TODO: To minified x-data files and point alias to dist folder
// TODO: Update alias link to the dist folder
// Possibly we can do this without needing to register them in here but we would need to first compile them via glob in rollup

const templatePath = `${siteConfig.context}/.resources/sanofi-lm-templates/themes/templates/dist/js/x-data`;

// Global
Alpine.asyncData("advancedSearch", () => import(`${templatePath}/advancedSearch/index.min.js`));
Alpine.asyncData("app", () => import(`${templatePath}/app/index.min.js`));
Alpine.asyncData("charts", () => import(`${templatePath}/charts/index.min.js`));
Alpine.asyncData("dateTime", () => import(`${templatePath}/dateTime/index.min.js`));
Alpine.asyncData("docCheck", () => import(`${templatePath}/docCheck/index.min.js`));
Alpine.asyncData("eventDetails", () => import(`${templatePath}/eventDetails/index.min.js`));
Alpine.asyncData("eventListing", () => import(`${templatePath}/eventListing/index.min.js`));
Alpine.asyncData("exitModal", () => import(`${templatePath}/exitModal/index.min.js`));
Alpine.asyncData("formComponent", () => import(`${templatePath}/formComponent/index.min.js`));
Alpine.asyncData("geolocation", () => import(`${templatePath}/geolocation/index.min.js`));
Alpine.asyncData("glossary", () => import(`${templatePath}/glossary/index.min.js`));
Alpine.asyncData("isi", () => import(`${templatePath}/isi/index.min.js`));
Alpine.asyncData("listingFilters", () => import(`${templatePath}/listingFilters/index.min.js`));
Alpine.asyncData("listingFiltersV2", () => import(`${templatePath}/listingFiltersV2/index.min.js`));
Alpine.asyncData("locator", () => import(`${templatePath}/locator/index.min.js`));
Alpine.asyncData("loginPicker", () => import(`${templatePath}/loginPicker/index.min.js`));
Alpine.asyncData("mediaPlaylist", () => import(`${templatePath}/mediaPlaylist/index.min.js`));
Alpine.asyncData("navSearchPanel", () => import(`${templatePath}/navSearchPanel/index.min.js`));
Alpine.asyncData("orderCenter", () => import(`${templatePath}/orderCenter/index.min.js`));
Alpine.asyncData("pageMenuLink", () => import(`${templatePath}/pageMenuLink/index.min.js`));
Alpine.asyncData("paywall", () => import(`${templatePath}/paywall/index.min.js`));
Alpine.asyncData("quiz", () => import(`${templatePath}/quiz/index.min.js`));
Alpine.asyncData("skipToMain", () => import(`${templatePath}/skipToMain/index.min.js`));
Alpine.asyncData("talentLmsButton", () => import(`${templatePath}/talentLmsButton/index.min.js`));
Alpine.asyncData("video", () => import(`${templatePath}/video/index.min.js`));

// Auth
Alpine.asyncData("changePassword", () => import(`${templatePath}/auth/changePassword/index.min.js`));
Alpine.asyncData("consentAcknowledge", () => import(`${templatePath}/auth/consentAcknowledge/index.min.js`));
Alpine.asyncData("editProfile", () => import(`${templatePath}/auth/editProfile/index.min.js`));
Alpine.asyncData("emailVerification", () => import(`${templatePath}/auth/emailVerification/index.min.js`));
Alpine.asyncData("emailVerificationRequired", () => import(`${templatePath}/auth/emailVerificationRequired/index.min.js`));
Alpine.asyncData("forgotPassword", () => import(`${templatePath}/auth/forgotPassword/index.min.js`));
Alpine.asyncData("incompleteProfile", () => import(`${templatePath}/auth/incompleteProfile/index.min.js`));
Alpine.asyncData("login", () => import(`${templatePath}/auth/login/index.min.js`));
Alpine.asyncData("loginNoAuth", () => import(`${templatePath}/auth/loginNoAuth/index.min.js`));
Alpine.asyncData("newsletter", () => import(`${templatePath}/auth/newsletter/index.min.js`));
Alpine.asyncData("profile", () => import(`${templatePath}/auth/profile/index.min.js`));
Alpine.asyncData("registration", () => import(`${templatePath}/auth/registration/index.min.js`));
Alpine.asyncData("resetPassword", () => import(`${templatePath}/auth/resetPassword/index.min.js`));
Alpine.asyncData("unsubscribe", () => import(`${templatePath}/auth/unsubscribe/index.min.js`));

// Decom
Alpine.asyncData("inventory", () => import(`${templatePath}/decom/inventory/index.min.js`));

// Uikit x-data
Alpine.asyncAlias(`${siteConfig.context}/.resources/sanofi-lm-uikit/themes/uikit/dist/js/x-data/[name]/index.min.js`);
